module.exports = __webpack_public_path__ + "img/QR_PlayStore.0abac180.jpg";